import { getSupplierTheme } from "@/utils/supplierCustomizationCache";
import PaymentMethodsFooter from "@/components/PaymentMethodsFooter";

const SupplierFooter = () => {
  const theme = getSupplierTheme();
  
  if (!theme.isDigitalMenu) return null;
  
  return (
    <footer className="bg-gray-50 border-t mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col items-center space-y-4">
          {/* Logo e nome do fornecedor */}
          {theme.logoUrl && (
            <img 
              src={theme.logoUrl} 
              alt={theme.supplierName || 'Fornecedor'} 
              className="h-12 object-contain"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          )}
          
          {theme.supplierName && !theme.logoUrl && (
            <h3 className="text-lg font-semibold text-gray-800">
              {theme.supplierName}
            </h3>
          )}
          
          {/* Formas de pagamento */}
          <PaymentMethodsFooter />
          
          {/* Copyright */}
          <p className="text-sm text-gray-500 text-center">
            © {new Date().getFullYear()} {theme.supplierName || 'Fornecedor'}. 
            <span className="block sm:inline sm:ml-1">Todos os direitos reservados.</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SupplierFooter;
